export default class ViewerManager {
  setDesign(designFile) {
    this.design = designFile;
  }

  createViewer(divId) {
    // Add configuration options for CORS
    const viewerConfiguration = {
      containerId: divId,
      endpointUri: this.design,
    };

    let viewer = new window.Communicator.WebViewer(viewerConfiguration);
    viewer.start();
    return viewer;
  }
}
